import { css } from '@emotion/react';
import { useTooltip } from '@frontend/design-system';
import { StatusBadge } from '../../../../../components/status-badge';

type VisibilityChipProps = {
  enabled: boolean;
  variant: 'online-scheduling' | 'ai-receptionist';
  tooltip: string;
  onClick: () => void;
  disableClick: boolean;
  disableClickTooltip: string;
};

export const VisibilityChip = ({
  enabled,
  variant,
  tooltip,
  onClick,
  disableClick,
  disableClickTooltip,
}: VisibilityChipProps) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip();

  const tooltipText = disableClick ? disableClickTooltip : tooltip;

  return (
    <>
      <button
        type='button'
        {...triggerProps}
        onClick={disableClick ? undefined : onClick}
        aria-label={tooltipText}
        aria-pressed={enabled}
        aria-disabled={disableClick}
        data-click-disabled={disableClick}
        css={visibilityButtonStyles}
      >
        <StatusBadge variant={variant} disabled={!enabled} />
      </button>
      <Tooltip {...tooltipProps}>{tooltipText}</Tooltip>
    </>
  );
};

const visibilityButtonStyles = css({
  appearance: 'none',
  border: 0,
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
  '> div': {
    transition: 'background 150ms ease, filter 150ms ease',
  },
  "& > div[data-disabled='false']": {
    border: '1px solid currentColor',
  },
  '&:hover > div': {
    filter: 'brightness(0.9) saturate(1.25)',
  },
  "&:hover > div[data-disabled='true']": {
    background: 'var(--fabric-color-surface-inset-hover)',
    filter: 'none',
  },
  "&[data-click-disabled='true']": {
    cursor: 'not-allowed',
    '> div': {
      opacity: 0.3,
      background: 'var(--fabric-color-surface-disabled)',
    },
    '&:hover > div': {
      filter: 'none',
    },
    "&:hover > div[data-disabled='true']": {
      background: 'var(--fabric-color-surface-disabled)',
    },
  },
});
